// l10n status: partial
import { CardMedia, Collapse, Grid, Typography, Button } from "@mui/material"
//import SwitchBase from "@mui/material/internal/SwitchBase"
//import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
//import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import { CreateComponent } from "components/utils/CreateComponent"
import { useState, useLayoutEffect, useEffect, createElement, useMemo, useRef } from "react"
import { EpgChannelDetailsToolsInfo, EpgChannelDetailsToolsTitleSecondary } from "scenes/components/EpgChannelDetailsTools"
import { RecordingButtons } from "scenes/components/RecordingButtons"
import { RecordingIndicators } from "scenes/components/RecordingIndicators"
//import defaultCoverImg from "img/cover-no-photo.gif"
import { rootStore } from "store/RootStore"
import ffAd_BlackCircle from "img/player/FFad_BlackCircle.svg"
import ffAd_icon from "img/player/ffAd_icon.svg"
// replaced with ConfirmationDialog
//import { SkipAdDialog, infoMsgSkipAd } from "./skipAdModal/skipAdModal"
import { ConfirmationDialog } from "components/ConfirmationDialog"
import { ROUTE_NAMES } from "site-ql/RouteConst"
import { useNavigateRouteAdd } from "components/utils/RouteUtils"
import { l10n } from "store/lang/L10n"

import { ButtonResume, ButtonPlay, ButtonLive, ButtonRestart, ButtonPremium, ButtonMore, ButtonInfo, ButtonRecordSeries, ButtonVisibility, ButtonArchive, ButtonGeneric, ButtonSwitchProfile, InfoPanel } from "./ButtonComponents"
import { observer } from "mobx-react"
import { DiscoverCarousel } from "scenes/Discover/DiscoverCarousel"
import { /*getChanges,*/ deepEqual } from "utils/CompareObjects"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { SourceTypeList } from "store/page/player/source/SourceTypeList"
import { useNavigate, useParams } from "react-router"
import { Mutex } from 'async-mutex'
import { startDateFormat, endDateFormat, durationInHoursAndMinutes, channelId, eventId, season, episode, isSeries, seriesId, seriesCollectionId,
			title, eventType, startTs, endTs, actors, directors, synopsis/*ageRating, language*/ } from "utils/EventHelpers"
import { BrokerEventPersonRole, EventDetailsMode } from "@quickline/coco"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import PinLock from "img/icons/pin_protected.svg"

//import "./EpgChannelDetailsInfo.css"
import "./../Overlay/OverlayEventDetails.css"

const styles = theme => ({
	EpgChannelDetailsRecording: { opacity: theme.typography.fontOpacity },
	EpgChannelDetailsLogoWrapper: { alignItems: "baseline", justifyContent: "flex-end", padding: "0px 0px 0px 0px", display: "flex", opacity: 0.7 },
	EpgChannelDetailsTextWrapper: { marginTop: -20, marginBottom: 0 },
	EpgChannelDetailsLogo: { maxWidth: 65, maxHeight: 65, marginLeft: 0, marginRight: 0 },
	EpgChannelDetailsAttribute: { display: "flex", marginTop: 3 },
	EpgChannelDetailsKey: { opacity: theme.typography.fontOpacity },
	EpgChannelDetailsValue: { paddingLeft: "20px" },//flexGrow: 0, flexShrink: 0, flexBasis: "77%" },
	EpgChannelDetailsInfo: {
		flex: 1,
		paddingLeft: "60px",
		//"&:first-child": { // generates warning
		"&:first-of-type": {
			paddingTop: 30,
			paddingBottom: 8,
		},
	},
	EpgChannelDetailsSwitch: {
		marginTop: "auto",
		"&:hover": {
			background: "none"
		}
	},
	EpgChannelDetailsBackgroundImg: {
		//MTV-2698
		//backgroundColor: "black",//"rgba(33, 31, 31, 0.5)",
		// backgroundRepeat: "no-repeat",
		//backgroundSize: "cover !important",

		//MTV-2759 padding: "24px 24px 0px 24px",
		// MTVW-810: commented
		//boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 2px 10px 0 rgba(0, 0, 0, 0.5)"
	},
	channelDetailInfo: { marginBottom: 0 },
})

const infoMsgSkipAd = {
	ALLOWED: "allowed",
	UNAVAILABLE: "unavailable",
	NOT_ALLOWED: "notAllowed"
}

export const PROGRAM_DETAILS_MODE = {
	desktop: "desktop",
	tabletOrMobile: "tabletOrMobile",
	liveTv: "liveTv"
}

export const PROGRAM_ORIGIN = {
	liveTv: "liveTv",
	tvGuide: "tvGuide",
	overlay: "overlay",
	// MTVW-931
	discover: "discover"
}

export const ProgramDetailsInfo = CreateComponent(styles, false, true, ({ page, oEventData, programDetailsMode, origin = PROGRAM_ORIGIN.overlay }) => {
	const nDash = '\u2013'
	// MTVW-810: resize
	// CAUTION: must fit @media (max-width: 540px) in OverlayEventDetails.css
	// Same value as in EpgChannelDetailsInfo.jsx
	const widthBreak = 800
	const [innerWidth, setInnerWidth] = useState(window.innerWidth)
	// MTVW-808: liveTv / overlay decoupling
	//const adSkipInfo = rootStore.page.OverlayEventDetails?.adSkipInfo
	const [adSkipInfo, setAdSkipInfo] = useState(null)

	//console.debug("ProgramDetailsInfo", origin, programDetailsMode)

	// don't use ...page.getMountBody, it would cause LiveTv to unmount/mount when closing OverlayDetails in LiveTv
	useEffect(() => {
		window.addEventListener("resize", handleResize)
		handleResize()
		setAdSkipInfo(null)
		return () => {
			window.removeEventListener("resize", handleResize)
		}
	}, [])

	// MTVW-808: liveTv / overlay decoupling, check channelId
	useEffect(() => {
		//console.debug("setAdSkipInfo", channelId(oEventData), rootStore.channelsService?.getChannel(channelId(oEventData))?.hasAlternativeAds ? rootStore.page.OverlayEventDetails?.adSkipInfo : null)
		if (rootStore.page.OverlayEventDetails?.adSkipInfo?.channelId === channelId(oEventData)) setAdSkipInfo(rootStore.page.OverlayEventDetails?.adSkipInfo)
	}, [rootStore.page.OverlayEventDetails?.adSkipInfo])

	useEffect(() => {
		setAdSkipInfo(null)
	}, [oEventData, origin])

	const handleResize = () => {
		setInnerWidth(window.innerWidth)
	}

	let styling = {}
	if (programDetailsMode === PROGRAM_DETAILS_MODE.tabletOrMobile)
		styling = { position: "relative", paddingLeft: 35, paddingRight: 0, paddingTop: 0 }
	else if (programDetailsMode === PROGRAM_DETAILS_MODE.liveTv)
		styling = { position: "relative", paddingLeft: 0, paddingRight: 0, paddingTop: 18 }

	//const MovieInfoMain = (() => {
	const MovieInfoMain = CreateComponent(styles, false, true, ({ classes, oEventData }) => {
		// MTVW-1129: guard with oEventData to avoid crash when event is not set yet
		return oEventData && (
			<div className="coverMovieInfoMainContainer">
				<div className="coverMovieInfoContainer">
					<div className="coverChannelLogoContainer">
						{/* MTVW-831: "mode=box&w=256" -> "mode=box&w=480&h=270" */}
						<img className="coverChannelLogo" src={rootStore.channelsService?.getChannel(channelId(oEventData))?.logoUrl + "?mode=box&w=480&h=270"} data-test="detail_info_channel" title={rootStore.channelsService?.getChannel(channelId(oEventData))?.Name} />
					</div>
					<div className="coverTimeContainer">
						<div className="coverDate" data-test="detail_info_date">{startDateFormat(oEventData?.event, "dddd, DD.MM.YYYY")}</div>
						<div className="coverTime" data-test="detail_info_time">{startDateFormat(oEventData?.event, "HH:mm")}{nDash}{endDateFormat(oEventData?.event, "HH:mm")} • {durationInHoursAndMinutes(oEventData?.event)}</div>
						{/* MTVW-983, MTVW-985, MTVW-986, MTVW-993 */}
						{/*(adSkipInfo?.adSkipping === infoMsgSkipAd.ALLOWED || adSkipInfo?.adSkipping === infoMsgSkipAd.NOT_ALLOWED) && */}
						{rootStore.page.Player.source.hasPremium(channelId(oEventData)) &&
							<div className="overlaySkipInfoContainer">
								<div className="overlaysSkipInfoBlackCircle">
									<img className="overlaysSkipInfoBlackCircleImg" src={ffAd_BlackCircle} alt=""></img>
									<div className="skipInfoWhiteIcon">
										<img className="skipInfoWhiteIconImg" src={ffAd_icon} alt=""></img>
									</div>
								</div>
								<div className="overlaySkipInfoText">
									{/*  MTVW-459: TODO check if the flag/text is correct??? premium user? */}
									{/* MTVW-983, MTVW-985, MTVW-986, MTVW-993 */}
									{/*adSkipInfo?.adSkipping === infoMsgSkipAd.ALLOWED ? l10n.featureDetailsAlternativeAdIndicatorTitleForPremium : l10n.featureDetailsAlternativeAdIndicatorTitleForNonPremium*/}
									{l10n.featureDetailsAlternativeAdIndicatorTitleForPremium}
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		)
	})

	//console.debug("programDetailsMode %s, origin %s inner %s, break %s", programDetailsMode, origin, innerWidth, widthBreak, title(oEventData))
	return (
		<>
			{/* CHECK || programDetailsMode === PROGRAM_DETAILS_MODE.liveTv */}
			{(programDetailsMode === PROGRAM_DETAILS_MODE.desktop && innerWidth > widthBreak) || ((programDetailsMode === PROGRAM_DETAILS_MODE.liveTv) /*&& origin === PROGRAM_ORIGIN.liveTv*/) ?
				<div id="coverMetadataContainer" className="coverMetadataContainer" style={styling} data-test="movie_details_container_dialog">
					{console.debug("PART 1", programDetailsMode)}
					<div className="coverTitleContainer"
						style={{flexDirection: rootStore.channelsService?.isChannelPinProtected(oEventData?.channel?.id) ? "row" : ""}}
					>
						{rootStore.channelsService?.isChannelPinProtected(oEventData?.channel?.id) &&
							<img style={{ width: 32, height: 32, marginTop: 4, marginRight: 10 }} src={PinLock}></img>
						}
						{/* MTVW-837: apply smaller font size in liveTv */}
						<div className="coverTitle" id="infoTitle" data-test="detail_info_title"
							style={programDetailsMode === PROGRAM_DETAILS_MODE.liveTv && origin === PROGRAM_ORIGIN.liveTv ?
								{ fontSize: "2.125rem", lineHeight: 1.235 }
								: {}
							}
						>
							{rootStore.channelsService?.isChannelPinProtected(oEventData?.channel?.id) ? 
								l10n.featureContentPinProtected : title(oEventData)
							}
						</div>
						{/* MTVW-1101: show also on mobile */}
						{/*innerWidth > widthBreak ?*/}
						{true ?
							<div className="coverEpisode" data-test="detail_info_meta_data">
								<EpgChannelDetailsToolsTitleSecondary innerWidth={innerWidth} widthBreak={widthBreak} oEventData={oEventData} suffix={<br />} />
							</div>
							: <></>
						}
					</div>
					<MovieInfoMain oEventData={oEventData} />
					{/* moved to Grid section, for width adjustment */}
					{/*<RecordingIndicators event={oEventData} showText={true} />*/}
				</div>
				:
				// tablet or mobile, liveTv
				<>{(programDetailsMode === PROGRAM_DETAILS_MODE.tabletOrMobile && innerWidth <= widthBreak) || origin === PROGRAM_ORIGIN.liveTv ?
					<div>
						{console.debug("PART 2", programDetailsMode)}
						<div className="coverTitleContainer" style={styling}>
							<div className="coverTitle" id="infoTitle" data-test="detail_info_title">
								{title(oEventData)}
							</div>
							{/* tablet or mobile */}
							<div className="coverEpisode" data-test="detail_info_meta_data">
								<EpgChannelDetailsToolsTitleSecondary innerWidth={innerWidth} widthBreak={widthBreak} oEventData={oEventData} suffix={<br />} />
							</div>
							<MovieInfoMain oEventData={oEventData} />
							{/* moved to Grid section, for width adjustment */}
							{/*<RecordingIndicators event={oEventData} showText={true} />*/}
						</div>
					</div>
					: <></>
				}</>
			}
		</>
	);
})

const mutex = new Mutex()
//let buttonsArray = []
let buttonsArray = {}
buttonsArray[PROGRAM_ORIGIN.liveTv] = []
buttonsArray[PROGRAM_ORIGIN.overlay] = []
console.debug("buttonsArray==", buttonsArray)

// page is OverlayEventDetails
export const EpgChannelDetailsInfo = CreateComponent(styles, false, true, ({ classes, oEventData, page, origin }) => {
	console.debug("FROM EpgChannelDetailsInfo component", origin, rootStore.page.OverlayEventDetails.callingContext, rootStore.page.OverlayEventDetails.isShow, rootStore.page.OverlayEventDetails.playEventStarted, rootStore.page.Player.isPlayerOnOverlay, title(oEventData))
	const navigate = useNavigate()
	const cocoBookmarks = rootStore.page.CoCoBookmarks

	const [bookmark, setBookmark] = useState(null)
	const [bookmarkFetched, setBookmarkFetched] = useState(false)
	const [panelInfo, setPanelInfo] = useState({})
	// MTVW-931: contentArrays
	const [episodesArray, setEpisodesArray] = useState(null)
	const [personsArray, setPersonsArray] = useState(null)

	/* MTVW-808: commented
	useLayoutEffect(() => {
				console.log("<EpgChannelDetailsInfo> clientHeight=%o", anchorEl.current.children[0].clientHeight)
		// .MuiTypography-paragraph {margin - bottom: 8px; }
		setCollapseToggle(anchorEl.current.children[0].clientHeight > defHeight + 8)
	}, [oEventData])
	*/

	// MTVW-931: episodesArray (moved from obsolete EpisodeCarousel)
	async function fetchEpisodes() {
		//MTVW-1075: episodes from CoCo
		setEpisodesArray(oEventData.moreEpisodes)
		return oEventData.moreEpisodes
	}

	// MTVW-808: personsArray (moved from obsolete PersonCarousel)
	const fetchPersons = () => {
		//console.debug("fetchPersons ovl event %o, oEventData %o", rootStore.page.OverlayEventDetails.event, oEventData)
		// oEventData is set depending on origin at the top of the component
		//debugger
		/*
		console.debug("fetchPersons origin=", origin, rootStore.page.Player.isInLiveTv, oEventData)
		console.debug("fetchPersons directors=", directors(oEventData))
		console.debug("fetchPersons actors=", actors(oEventData))
		console.debug("fetchPersons crew=", oEventData?.crew)
		*/

		rootStore.page.OverlayEventDetails.setGenre(null)
		rootStore.page.OverlayEventDetails.setActorName(null)

		//MTVW-1075: use crew from CoCo
		//setPersonsArray(oEventData.crew)
		const _actors = []
		const _directors = []
		for (var i = 0; i < oEventData?.crew?.length; i++) {
			if (oEventData.crew[i].role === BrokerEventPersonRole.Actor) _actors.push(oEventData.crew[i])
			else if (oEventData.crew[i].role === BrokerEventPersonRole.Director) _directors.push(oEventData.crew[i])
		}
		setPersonsArray(_actors.concat(_directors))
	}

	const setupPanelInfo = (pInfo) => {
		// check for undefined to prevent erroneous display
		if (pInfo.isSubscribed !== undefined && !pInfo.isSubscribed) {
			setPanelInfo({info: l10n.infopanelChannelNotSubscribed, buttonLabel: l10n.commonActionToMyQuickline,
				action: (e) => {
					e.preventDefault()
					window.open(l10n.featureAdditionalPackagesUrl?.format(rootStore?.sso?.contractId), "_blank")
				}
			})
		}
		/* MTVW-1073: disabled
		else if (pInfo.optinDate !== undefined && pInfo.optinDate === 0) {
			setPanelInfo({info: l10n.infopanelChannelReplayNotEnabled, buttonLabel: l10n.featureSettingsReplayTitle,
				 action: (e) => {
					e.preventDefault()
					checkForProfileSwitch()
				}
			})
		}
		*/
		else if (pInfo.hasReplay !== undefined && !pInfo.hasReplay) {
			setPanelInfo({info: l10n.infopanelChannelWithoutReplay, action: emptyAction})
		}
		else if (pInfo.replayAllowed !== undefined && !pInfo.replayAllowed) {
			setPanelInfo({info: l10n.infopanelProgramNotWithinReplayWindow, action: emptyAction})
		}
		// MTVW-1162
		else setPanelInfo({})
	}

	useEffect(() => {
		setAdSkipInfo(null)
		btns = []
		buttonsArray[origin] = []
		setButtons([])
		const pInfo = rootStore.page.MsEpg?.panelInfo(oEventData)
		//console.debug("panelInfo", channelId(oEventData), pInfo)
		setupPanelInfo(pInfo)
		return (() => {
			setBookmark(null)
			setBookmarkFetched(false)
		})
	}, [])

	useLayoutEffect(() => {
		//console.debug("useLayoutEffect=", rootStore.page.Player.player?.settings.isFullScreen)
		// MTVW-754: added
		rootStore.page.Player.adjustPlayerStyles()
	})

	useEffect(() => {
		//console.debug("callingContext", page.callingContext, rootStore.page.OverlayEventDetails.isShow)
		//setPersonsArray([])
		// MTVW-1075, finding 3: don't reset adSkipInfo!
		//setAdSkipInfo(null)
		btns = []
		buttonsArray[origin] = []
		// MTVW-1103: importatn condition added to avoid flicker
		if (oEventData.mode === EventDetailsMode.Lite) {
			setButtons([])
		}
		const pInfo = rootStore.page.MsEpg?.panelInfo(oEventData)
		//console.debug("panelInfo", channelId(oEventData), pInfo, pInfo)
		setupPanelInfo(pInfo)
		// MTVW-931: episodesArray and personsArray
		fetchEpisodes().then((res) => {
		}).catch((e) => {
			// make sure to catch any error
			console.error("fetchEpisodes", e)
		})
		try {
			fetchPersons()
		}
		catch (e) {
			// make sure to catch any error
			console.error("fetchPersons", e)
		}


		// MTVW-417 in case the event is live rootStore.page.OverlayEventDetails.adSkipInfo=null
	}, [/*rootStore.page.OverlayEventDetails.oEvent,*/ oEventData, origin])

	// MTVW-808: liveTv / overlay decoupling, check channelId
	useEffect(() => {
		//console.debug("setAdSkipInfo", channelId(oEventData), rootStore.channelsService?.getChannel(channelId(oEventData))?.hasAlternativeAds ? rootStore.page.OverlayEventDetails?.adSkipInfo : null)
		//console.debug("setAdSkipInfo", channelId(oEventData), rootStore.page.OverlayEventDetails?.adSkipInfo?.channelId === channelId(oEventData), rootStore.page.OverlayEventDetails?.adSkipInfo)
		if (rootStore.page.OverlayEventDetails?.adSkipInfo?.channelId === channelId(oEventData)) setAdSkipInfo(rootStore.page.OverlayEventDetails?.adSkipInfo)
	}, [rootStore.page.OverlayEventDetails?.adSkipInfo])

	useEffect(() => {
		console.debug("useEffect bookmark 1", bookmark, eventId(oEventData), oEventData)
		// MTVW-1036: reload true so that bookmark is up-to-date
		if (cocoBookmarks.refreshCount) cocoBookmarks.getBookmarkAsync(oEventData, true).then((bm) => {
			if (!deepEqual(bm, bookmark)) {
				console.debug("useEffect bookmark 2", bm, bookmark)
				setBookmark(bm)
			}
			setBookmarkFetched(true)
		})

		return () => {
			//console.debug("~useEffect EpgChannelDetailsInfo", oEventData)
			rootStore.page.Recordings.Manager.closeRecordingEvent(oEventData)
		}
	}, [cocoBookmarks.refreshCount])

	/* MTVW-808: commented
	const anchorEl = useRef(null)
	const [isCollapseToggle, setCollapseToggle] = useState(false)
	const defHeight = 35
	const nDash = '\u2013'
	*/
	// MTVW-808: event decoupling
	//console.debug("oEventData= in l %o, o %o", origin, oEventData.event.start, rootStore.page.OverlayEventDetails.event.event.start)
	oEventData = origin === PROGRAM_ORIGIN.liveTv ? oEventData : rootStore.page.OverlayEventDetails.event
	//console.debug("oEventData= out l %o, o %o", origin, oEventData.event.start)

	const [openSkipAd, setOpenSkipAd] = useState(false)
	// MTVW-808: liveTv / overlay decoupling
	//const adSkipInfo = rootStore.page.OverlayEventDetails?.adSkipInfo
	const [adSkipInfo, setAdSkipInfo] = useState(null)
	const [replaySetting, setReplaySetting] = useState(false)

	function closeSkipAdModal() {
		setOpenSkipAd(false)
	}
	const upsellGt12Link = rootStore?.sso?.contractId ? l10n.featureUpsellGt12Link + `?contractId=${rootStore?.sso?.contractId}` : l10n.featureUpsellGt12Link

	const navigateRouteAdd = useNavigateRouteAdd()

	const [buttons, setButtons] = useState([])

	let btns = [...buttonsArray[origin]]
	const buttonAdd = (button, props) => {
		mutex.acquire().then(release => {
			///console.debug("buttonAdd=", props.bId)
			const len = btns.length

			const filtered = btns.filter(item => item.props.bId === props.bId)
			let buttonChanged = false
			if (filtered.length === 0) btns.push({ button: button, props: props })
			else if (props.bId === `buttonMore_${origin}`) {
				// buttonMore can change, replace it and signal buttonChanged
				const buttonIx = btns.findIndex(item => item.props.bId === `buttonMore_${origin}`)
				//const changes = buttonIx >= 0 ? getChanges(btns[buttonIx].props.contentMore, props.contentMore) : []
				const changes = buttonIx >= 0 ? !deepEqual(btns[buttonIx].props.contentMore, props.contentMore) : false
				console.debug("buttonMore changes %s, btnsMore %o, propsMore %o", changes, btns[buttonIx].props.contentMore, props.contentMore)
				if (changes) {
					btns[buttonIx] = { button: button, props: props }
					console.debug("replacing", `buttonMore_${origin}`, props)
					buttonChanged = true
				}
			}
			//console.debug("buttonAdd %s %s", filtered.length === 0 ? "pushing" : "duplicate", props.bId)
			//setTimeout(() => {
			/*
			const changes = getChanges(buttonsArray[origin], btns)
			if (changes.length > 0) console.debug("buttonAdd changes", changes.length, changes, buttonsArray[origin], btns)
			//if (btns.length !== len || buttonChanged) {
			if (changes.length > 0) {
				buttonsArray[origin] = [...btns]
				// this will triger RenderButtons, have avoid too many renders!
				setButtons(buttonsArray[origin])
				console.debug("buttonAdd setting", props.bId, btns.length, btns)
			}
			*/
			//},)
			release()
		})
	}

	const buttonRemove = (bId) => {
		mutex.acquire().then(release => {
			const filtered = btns.filter(item => item.props.bId !== bId)
			//setTimeout(() => {
			if (btns.length !== filtered.length) {
				const buttonIx = btns.findIndex(item => item.props.bId === bId)
				btns.splice(buttonIx, 1)
				//btns = [...filtered]
				/*
				buttonsArray[origin] = [...filtered]
				setButtons(buttonsArray[origin])
				*/
				///console.debug("buttonRemove setting", bId, filtered.length, filtered)
			}
			//}, 100)
			release()
		})
	}

	const buttonsPlaybuttonsRemove = () => {
		buttonRemove(`buttonLive_${origin}`)
		buttonRemove(`buttonPlay_${origin}`)
		buttonRemove(`buttonResume_${origin}`)
		buttonRemove(`buttonRestart_${origin}`)
	}

	const buttonsCollect = () => {
		mutex.acquire().then(release => {
			console.debug("buttonsCollect")
			//btns = []//[...buttonsArray[origin]] //[]
			buttonsArray[origin] = [...btns]
			//buttonsArray[origin] = []
			//setButtons(buttonsArray[origin])
			release()
		})
	}

	const buttonsCommit = (reason) => {
		mutex.acquire().then(release => {
			console.debug("buttonsCommit", reason, buttonsArray[origin], btns)
			//const changes = getChanges(buttonsArray[origin], btns)
			const changes = !deepEqual(buttonsArray[origin], btns)
			if (changes || buttons.length != btns.length) console.debug("buttonsCommit changes %s, bArray %o, btns %o, buttons %o", changes, buttonsArray[origin], btns, buttons)
			//if (btns.length !== len || buttonChanged) {
			if (changes || buttons.length != btns.length) {
				buttonsArray[origin] = [...btns]
				// this will triger RenderButtons, have avoid too many renders!
				setButtons(buttonsArray[origin])
				console.debug("buttonsCommit setting", btns.length, btns)
			}
			//buttonsArray[origin] = []
			//setButtons(buttonsArray[origin])
			release()
		})
	}

	/*
	const RenderButtonsTest = observer(({ bArray }) => {
		const lastLayout = useRef(null)

		if (!oEventData?.event?.id || bArray.length === 0) return null

		const seriesOrEpisodeText = (season(oEventData) || episode(oEventData)) 
			? l10n.featureRecordingsSeasonRecording 
			: l10n.featureRecordingsSeriesRecording

		const sortedButtons = useMemo(() => {
			const renderArray = [...bArray]
			const trailingButtons = [
				`buttonMore_${origin}`,
				`buttoInfo_${origin}`,
				`buttonPremium_${origin}`
			]

			trailingButtons.forEach(id => {
				const buttonIx = renderArray.findIndex(item => item.props.bId === id)
				if (buttonIx >= 0) {
					const [item] = renderArray.splice(buttonIx, 1)
					renderArray.push(item)
				}
			})
			return renderArray
		}, [bArray.length, origin, oEventData?.event?.id])

		// If we are freezing AND we have something saved, show it.
		// not working, lastLayout.current is always null
		console.debug("oEventData?.mode", oEventData?.mode, lastLayout.current)
		if (oEventData?.mode === EventDetailsMode.Full && lastLayout.current) {
			console.debug("Returning Frozen Layout")
			return lastLayout.current
		}

		const result = (
			<>
				{console.debug("retransmissionNotRecorded", rootStore.page.Recordings.Manager.retransmissionNotRecorded)}
				{rootStore.page.Recordings.Manager.retransmissionNotRecorded &&
					<ConfirmationDialog
						title={seriesOrEpisodeText}
						onCloseHandler={() => rootStore.page.Recordings.Manager.setRetransmissionNotRecorded(false)}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonDismiss_${origin}`, variant: "primary",
									label: l10n.commonActionOk,
									onClick: function () {
										rootStore.page.Recordings.Manager.setRetransmissionNotRecorded(false)
									},
									dataTest: "dismiss"
								}
							}
							]}
					>
						{l10n.dialogRetransmissionHintDescription.format(seriesOrEpisodeText).replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				}

				{console.debug("RenderButtons", sortedButtons.length)}

				{sortedButtons.map((item, ix) => {
					return createElement(item.button, {
						...item.props,
						key: item.props.bId,
						variant: ix === 0 ? "primary" : "secondary"
				})
				})}
			</>
		)

		lastLayout.current = result
		console.debug("lastLayout.current1", lastLayout.current)
  		return result
	})
	*/

	const RenderButtons = observer(({ bArray }) => {
		// make a copy of the useState array
		const renderArray = [...bArray]
		//const test = createElement(ButtonLive, { variant: "secondary", bId: "test", label: l10n.commonLabelLive, onClick: (e) => { onPlayClick(e, "c", oEventData) } }, null)
		const trailingButtons = [`buttonMore_${origin}`, `buttoInfo_${origin}`, `buttonPremium_${origin}`]
		let trailing = null
		for (var i = 0; i < trailingButtons.length; i++) {
			const buttonIx = renderArray.findIndex(item => item.props.bId === trailingButtons[i])
			if (buttonIx >= 0) {
				trailing = renderArray[buttonIx]
				// move premium to end of array
				renderArray.splice(buttonIx, 1)
				renderArray.push(trailing)
				console.debug("buttonIx", buttonIx)
			}
		}

		const seriesOrEpisodeText = season(oEventData) || episode(oEventData) ? l10n.featureRecordingsSeasonRecording : l10n.featureRecordingsSeriesRecording

		return (
			<>
				{console.debug("retransmissionNotRecorded", rootStore.page.Recordings.Manager.retransmissionNotRecorded)}
				{rootStore.page.Recordings.Manager.retransmissionNotRecorded &&
					<ConfirmationDialog
						title={seriesOrEpisodeText}
						onCloseHandler={() => rootStore.page.Recordings.Manager.setRetransmissionNotRecorded(false)}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonDismiss_${origin}`, variant: "primary",
									label: l10n.commonActionOk,
									onClick: function () {
										rootStore.page.Recordings.Manager.setRetransmissionNotRecorded(false)
									},
									dataTest: "dismiss"
								}
							}
							]}
					>
						{l10n.dialogRetransmissionHintDescription.format(seriesOrEpisodeText).replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				}
				{/*test*/}
				{console.debug("RenderButtons", renderArray.length)}
				{renderArray.map((item, ix) => {
					item.props.variant = ix === 0 ? "primary" : "secondary"
					item.props.key = ix
					console.debug("props=", item.props.bId)
					return createElement(item.button, item.props, null)
				})}

				{/*}
				<ButtonMore bId={`buttonMore_${origin}`} onClick={(e) => console.debug("TODO")} />
				<ButtonInfo bId={`buttonInfo_${origin}`} onClick={(e) => console.debug("TODO")} />

				<ButtonRecordSeries label="Season 5 aufnehmen" onClick={(e) => console.debug("TODO")} />
				<ButtonVisibility label="In allen Profilen aktivieren" onClick={(e) => console.debug("TODO")} />
				<ButtonArchive label="Archivieren" onClick={(e) => console.debug("TODO")} />
				<ButtonSwitchProfile label="Profil wechseln" onClick={(e) => console.debug("TODO")} />
				<ButtonGeneric variant="primary" label="Aufnahme löschen" onClick={(e) => console.debug("TODO")} />
				<ButtonGeneric variant="secondary" label="Schliessen" onClick={(e) => console.debug("TODO")} />
				<ButtonRestart variant="secondary" label={l10n.commonActionRestart} onClick={(e) => console.debug("TODO")} />
				<ButtonRestart variant="primary" label={l10n.commonActionRestart} onClick={(e) => console.debug("TODO")} />
				*/}
			</>
		)
	})

	const PlayButtons = () => {
		//buttonsArray[origin] = []
		{/* MTVW-708: ANSEHEN Button */ }
		{/*console.debug("Ansehen button isShow %s, bEnabled %s, !started %s, origin %s, ctx %s, type %s, evt %o", rootStore.page.OverlayEventDetails.isShow, rootStore.page.OverlayEventDetails.isPlayButtonEnabled, !rootStore.page.OverlayEventDetails.playEventStarted, origin, rootStore.page.OverlayEventDetails.context, eventType(oEventData), oEventData)*/ }
		{/* MTVW-810: liveTv / overlay decoupling, show only for origin === PROGRAM_ORIGIN.overlay */ }
		// MTVW-931, finding 3: first if condition add eventId(rootStore.page.Player.source.GetEvent) === eventId(oEventData)
		console.debug("PlayButtons=", eventType(oEventData), origin, rootStore.page.OverlayEventDetails.callingContext, title(oEventData), rootStore.page.OverlayEventDetails.isShow, rootStore.page.OverlayEventDetails.isPlayButtonEnabled, rootStore.page.OverlayEventDetails.playEventStarted, rootStore.page.Player.source, oEventData)
		if (rootStore.page.OverlayEventDetails.callingContext === CALLING_CONTEXT_TYPE.TvInfo && rootStore.page.OverlayEventDetails.isShow && eventId(rootStore.page.Player.source.GetEvent) === eventId(oEventData)) {
			// MTVW-811
			console.debug("PlayButtons bookmark TvInfo", bookmark, eventType(oEventData))
			if (eventType(oEventData) === "c" && (channelId(rootStore.page.Player.source?.GetEvent) !== channelId(oEventData) || rootStore.page.Player.source.type !== SourceTypeList.ChannelLive)) {
				buttonAdd(ButtonLive, {
					bId: `buttonLive_${origin}`, label: l10n.commonLabelLive,
					onClick: (e) => { onPlayClick(e, "c", oEventData) }, dataTest: "view_button", event: oEventData
				})
			}
			// MTVW-899: don't hide anymore
			if (bookmark /*&& !bookmark.hidden*/) {
				//console.debug("activeChannelId", rootStore.channelsService.activeChannelId, oEventData, rootStore.page.Player.source)
				// MTVW-882: Tapping on the info button for the currently playing program shouldn’t show a Resume button even if there would
				// be a bookmark since you are already watching it and you just need to close the details.
				if (rootStore.channelsService.activeChannelId !== channelId(oEventData)) {
					buttonAdd(ButtonResume, {
						bId: `buttonResume_${origin}`, label: l10n.commonActionResume,
						onClick: (e) => { rootStore.page.CoCoBookmarks.setIgnoreEvent(null); onPlayClick(e, "b", oEventData) }, dataTest: "resume_button", event: oEventData, bookmark: bookmark
					})
				}
			}
			{/* MTVW-870 */ }
			// MTVW-887: Don't show "restart" button if program has a bookmark and is live
			// MTVW-899: don't hide anymore
			if (((!bookmark) /*|| bookmark?.hidden*/) && channelId(rootStore.page.Player.source?.GetEvent) !== channelId(oEventData)) {
				if (rootStore.page.MsEpg?.isReplayAllowed(channelId(oEventData), startTs(oEventData), endTs(oEventData))) {
					buttonAdd(ButtonRestart, {
						bId: `buttonRestart_${origin}`, label: l10n.commonActionRestart,
						onClick: (e) => { rootStore.page.CoCoBookmarks.setIgnoreEvent(oEventData); onPlayClick(e, "p", oEventData) }, dataTest: "view_restart"
					})
				}
				//else buttonRemove(`buttonRestart_${origin}`)
			}
		}
		else if (rootStore.page.OverlayEventDetails.isShow && rootStore.page.OverlayEventDetails.isPlayButtonEnabled && !rootStore.page.OverlayEventDetails.playEventStarted && origin === PROGRAM_ORIGIN.overlay) {
			// MTVW-811
			console.debug("PlayButtons bookmark", bookmark, eventType(oEventData))
			if (eventType(oEventData) === "c") {
				buttonAdd(ButtonLive, {
					bId: `buttonLive_${origin}`, label: l10n.commonLabelLive,
					onClick: (e) => { onPlayClick(e, "c", oEventData) }, dataTest: "view_button", event: oEventData
				})
				// MTVW-899: don't hide anymore
				if (bookmark /*&& !bookmark.hidden*/) {
					//console.debug("activeChannelId", rootStore.channelsService.activeChannelId, oEventData, rootStore.page.Player.source)
					buttonAdd(ButtonResume, {
						bId: `buttonResume_${origin}`, label: l10n.commonActionResume,
						onClick: (e) => { rootStore.page.CoCoBookmarks.setIgnoreEvent(null); onPlayClick(e, "b", oEventData) }, dataTest: "resume_button", event: oEventData, bookmark: bookmark
					})
				}
				// MTVW-887: Don't show "restart" button if program has a bookmark and is live
				// MTVW-864, finding 8: comment || rootStore.page.OverlayEventDetails.callingContext !== CALLING_CONTEXT_TYPE.TvLive
				if (!bookmark /*|| rootStore.page.OverlayEventDetails.callingContext !== CALLING_CONTEXT_TYPE.TvLive*/) {
					if (rootStore.page.MsEpg?.isReplayAllowed(channelId(oEventData), startTs(oEventData), endTs(oEventData))) {
						buttonAdd(ButtonRestart, {
							bId: `buttonRestart_${origin}`, label: l10n.commonActionRestart,
							onClick: (e) => { rootStore.page.CoCoBookmarks.setIgnoreEvent(oEventData); onPlayClick(e, "p", oEventData) }, dataTest: "view_restart"
						})
					}
					//else buttonRemove(`buttonRestart_${origin}`)
				}
			}
			else {
				//buttonRemove(`buttonLive_${origin}`)
				//buttonRemove(`buttonRestart_${origin}`)
				if (bookmarkFetched) {
					buttonAdd(ButtonPlay, {
						bId: `buttonPlay_${origin}`, label: l10n.featureDetailsPlayAction,
						// MTVW-899: don't hide anymore
						onClick: (e) => { onPlayClick(e, bookmark/*?.hidden*/ ? "b" : "", oEventData) },
						dataTest: "view_button"
					})
				}
				// MTVW-899: don't hide anymore
				if (bookmark /*&& !bookmark.hidden*/) {
					buttonRemove(`buttonPlay_${origin}`)
					buttonAdd(ButtonResume, {
						bId: `buttonResume_${origin}`, label: l10n.commonActionResume,
						onClick: (e) => { rootStore.page.CoCoBookmarks.setIgnoreEvent(null); onPlayClick(e, "b", oEventData) }, dataTest: "resume_button", event: oEventData, bookmark: bookmark
					})
					{/* MTVW-870 */ }
					buttonAdd(ButtonRestart, {
						bId: `buttonRestart_${origin}`, label: l10n.commonActionRestart,
						onClick: (e) => { rootStore.page.CoCoBookmarks.setIgnoreEvent(oEventData); onPlayClick(e, "p", oEventData) }, dataTest: "view_restart"
					})
				}
			}
		}
		else {
			// probably not necessary with buttonsCommit
			buttonsPlaybuttonsRemove()
		}
		buttonsCommit("PlayButtons")
		//setButtons(buttonsArray[origin])
		//buttonsArray[origin] = [...buttonsArray[origin]]
		return <></>
	}

	/*
	const showPremium = () => {
		return adSkipInfo?.adSkipping === infoMsgSkipAd.NOT_ALLOWED
	}
	*/

	const SubsribePremiumButton = () => {
		{/* MTVW-459
		{rootStore.page.OverlayEventDetails.adSkipInfo !== null && rootStore.page.OverlayEventDetails.adSkipInfo?.adSkipping !== infoMsgSkipAd.UNAVAILABLE && <div
		*/}
		// MTVW-983, MTVW-985, MTVW-986, MTVW-993
		//if (showPremium()) {
		if (rootStore.page.Player.source.hasReplayPremiumButton(channelId(oEventData))) {
			buttonAdd(ButtonPremium, {
				bId: `buttonPremium_${origin}`, label: l10n.featureDetailsAdSkipInfoButtonTitle,
				onClick: (e) => {
					e.stopPropagation()
					setOpenSkipAd(true)
				}, dataTest: "view_premium"
			})
		}
		else buttonRemove(`buttonPremium_${origin}`)
		buttonsCommit("SubsribePremiumButton")
		return <></>
	}

	// MTVW-811: factored out
	const onPlayClick = (e, selectedType, oEventData) => {
		e.stopPropagation()
		e.preventDefault()
		console.debug("onPlayClick", eventId(oEventData), oEventData)
		btns = []
		buttonsArray[origin] = []
		setButtons([])
		//rootStore.page.OverlayEventDetails.setEpgEventById(eventId(oEventData), false, {})
		if (rootStore.page.Player.isInLiveTv) {
			rootStore.page.OverlayEventDetails.setShow(false)
			rootStore.page.MiniEpg.setShow(false)
			/* TODO: Possibly recheck
			if (selectedType === "c") {
				rootStore.page.Player.handleChangeChannel(channelId(oEventData))
			}
			*/
		}

		//rootStore.page.OverlayEventDetails.setPlayEvent(false, selectedType)//.then(() => {
		if (selectedType === "b") {
			// MTVW-998: A recording with a bookmark could have been deleted, and if the show is still in
			// the replay window, we have to reset the content play list to avoid a 'not found' error
			rootStore.page.OverlayEventDetails.setTypeContentPlaylist(null)
			rootStore.page.OverlayEventDetails.setEpgEventById(eventId(oEventData), false, {}).then(() => {
				rootStore.page.OverlayEventDetails.setPlayEvent(false, selectedType)
			})
		}
		else rootStore.page.OverlayEventDetails.setPlayEvent(false, selectedType)//.then(() => {
		rootStore.page.LiveTv.memoSelectedEpg = null //MTV-3740 restore the snapshot for the channelList used in EpgChannel.js
		// MTVW-727b: use isInLiveTv
		if (!rootStore.page.Player.isInLiveTv) { // was rootStore.page.Player.playerLiveTvVo.isPlayerActive === false
			rootStore.page.OverlayEventDetails.setIsPlayerPresent(true)
		} else {
			/* MTVW-810: moved above before setPlayEvent
			rootStore.page.OverlayEventDetails.setShow(false)
			rootStore.page.MiniEpg.setShow(false)
			*/
			// MTVW-624: combined activityStack for related content and search
			rootStore.page.OverlayEventDetails.resetActivity()
			navigateRouteAdd(ROUTE_NAMES.LiveTv)
		}
		setTimeout(() => {
			//window.scrollTo(0, 0)
			let elem = document.getElementById("tvLiveAndDetailsContainer")
			if (elem) elem.scrollTop = 0
			// MTVW-810
			elem = document.getElementsByClassName("MuiDialog-container")
			//console.debug("overlay-dialog", elem)
			if (elem?.length > 0) elem[0].scrollTop = 0
		}, 100)
	}

	//{origin === PROGRAM_ORIGIN.liveTv || !rootStore.page.OverlayEventDetails.isShow /*&& !rootStore.page.Player.isPlayerOnOverlay && page.callingContext !== CALLING_CONTEXT_TYPE.TvLive*/ || rootStore.page.OverlayEventDetails.playEventStarted ?

	const getMainProfile = () => {
		const mainProfile = rootStore.sso.profileOrder.filter(i => {
			return (i?.isMainProfile === true)
		})
		if (mainProfile.length === 1) {
			//console.debug("mainProfile", mainProfile[0].name, mainProfile)
			return mainProfile[0]
		}
		return null
	}

	const jumpToReplaySetting = (switchProfile) => {
		rootStore.page.OverlayEventDetails.setShow(false)
		if (switchProfile) rootStore.sso.handleChangeProfile(getMainProfile()?.id, false)
		setTimeout(() => {
			//console.debug("href", href)
			// setting window.location.href causes error on Safari
			//location.hash = "replaySetting"
			//history.push(ROUTE_NAMES.Settings + "?name=replaySetting")
			navigate("/" + ROUTE_NAMES.Settings + "?name=replaySetting")
		}, 100)
	}

	const checkForProfileSwitch = () => {
		const currentProfileId = rootStore.sso?.profile?.id ?? rootStore.sso.browserStore.currentProfileId
		console.debug("current profile", currentProfileId)
		if (currentProfileId === getMainProfile()?.id) {
			jumpToReplaySetting(false)
		}
		else setReplaySetting(true)
	}

	const emptyAction = () => {
	}

	const replayInfo = [{
		bType: ButtonSwitchProfile, props: {
			bId: `buttonSwitchProfile_${origin}`, label: l10n.commonActionSwitchProfile,
			onClick: () => {
				//rootStore.page.Player.player.stopInstance()
				// make sure that movie poster is displayed
				//rootStore.page.OverlayEventDetails.setIsPlayerPresent(false)
				jumpToReplaySetting(true)
			}, dataTest: "switch_profile"
		}
	},
	{
		bType: null, props: null
	}]

	// MTVW-898: stop playing and open the detail page of the new episode
	const resetOverlayDetailsForEpisodeCarousel = () => {
		rootStore.page.OverlayEventDetails.setPlayEventStarted(false)
		if (rootStore.page.OverlayEventDetails.isPlayerPresent) {
			rootStore.page.OverlayEventDetails.setIsPlayerPresent(false)
		}
	}

	if (rootStore.channelsService?.isChannelPinProtected(oEventData?.channel?.id)) {
		return (
			<div id="epgChannelDetailsInfo" /*style={{ zIndex: 100000 }}*/ className={classes.EpgChannelDetailsBackgroundImg}  >
				<Grid container >
					<Grid size={12}>
						{/* MTVW-810: liveTv / overlay decoupling, show ProgramDetailsInfo if origin === PROGRAM_ORIGIN.liveTv */}
						{origin === PROGRAM_ORIGIN.liveTv || !rootStore.page.OverlayEventDetails.isShow /*&& !rootStore.page.Player.isPlayerOnOverlay && page.callingContext !== CALLING_CONTEXT_TYPE.TvLive*/ || rootStore.page.OverlayEventDetails.playEventStarted ?
							<div>
								{console.debug("FROM EpgChannelDetailsInfo 1", origin, rootStore.page.OverlayEventDetails.callingContext, rootStore.page.OverlayEventDetails.isShow, rootStore.page.OverlayEventDetails.playEventStarted, rootStore.page.Player.isPlayerOnOverlay, title(oEventData))}
								{/* MTVW-864, finding 1 and 7: restore previous code
								<ProgramDetailsInfo page={page} oEventData={oEventData} programDetailsMode={origin === PROGRAM_ORIGIN.liveTv ? PROGRAM_DETAILS_MODE.liveTv : PROGRAM_DETAILS_MODE.desktop} origin={origin} />
								*/}
								<ProgramDetailsInfo page={page} oEventData={oEventData} programDetailsMode={PROGRAM_ORIGIN.liveTv} origin={origin} />
							</div>
							: <></>
						}
					</Grid>
				</Grid>
			</div>
		)
	}

	return (
		oEventData && (
			<div id="epgChannelDetailsInfo" /*style={{ zIndex: 100000 }}*/ className={classes.EpgChannelDetailsBackgroundImg}>
				{/* OLD implementation */}
				{/*
				<SkipAdDialog open={openSkipAd} close={closeSkipAdModal} adSkipping={adSkipInfo} />
				*/}
				{/* NEW implementation */}
				{openSkipAd ?
					<ConfirmationDialog
						title={adSkipInfo?.adButtonTitle}
						onCloseHandler={closeSkipAdModal}
						bottomButtons={[
							{
								bType: ButtonGeneric,
								props: {
									bId: `skipAd_cancel`, variant: "secondary",
									label: l10n.featureUpsellGt12ButtonLaterTitle,
									onClick: function () {
										closeSkipAdModal()
									},
									dataTest: "cancel"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `skipAd_confirm`, variant: "primary",
									label: l10n.featureUpsellGt12ButtonTitle,
									onClick: function () {
										window.open(upsellGt12Link)
										closeSkipAdModal()
									},
									dataTest: "confirm"
								}
							}
						]}
					>
						{adSkipInfo?.adButtonText}
					</ConfirmationDialog>
					: <></>
				}
				<Grid container>
					<Grid size={12}>
						{/* MTVW-810: liveTv / overlay decoupling, show ProgramDetailsInfo if origin === PROGRAM_ORIGIN.liveTv */}
						{origin === PROGRAM_ORIGIN.liveTv || !rootStore.page.OverlayEventDetails.isShow /*&& !rootStore.page.Player.isPlayerOnOverlay && page.callingContext !== CALLING_CONTEXT_TYPE.TvLive*/ || rootStore.page.OverlayEventDetails.playEventStarted ?
							<div>
								{console.debug("FROM EpgChannelDetailsInfo 2", origin, rootStore.page.OverlayEventDetails.callingContext, rootStore.page.OverlayEventDetails.isShow, rootStore.page.OverlayEventDetails.playEventStarted, rootStore.page.Player.isPlayerOnOverlay, title(oEventData))}
								{/* MTVW-864, finding 1 and 7: restore previous code
								<ProgramDetailsInfo page={page} oEventData={oEventData} programDetailsMode={origin === PROGRAM_ORIGIN.liveTv ? PROGRAM_DETAILS_MODE.liveTv : PROGRAM_DETAILS_MODE.desktop} origin={origin} />
								*/}
								<ProgramDetailsInfo page={page} oEventData={oEventData} programDetailsMode={PROGRAM_ORIGIN.liveTv} origin={origin} />
							</div>
							: <></>
						}
						<Grid size={12}>
							<RecordingIndicators event={oEventData} showText={true} />
						</Grid>
						{/* MTVW-459 */}
						{/*
						{(adSkipInfo?.adSkipping === infoMsgSkipAd.ALLOWED || adSkipInfo?.adSkipping === infoMsgSkipAd.NOT_ALLOWED) && <div className={classes.overlaySkipInfoContainer}>
							<div className={classes.overlaysSkipInfoBlackCircle} style={{ paddingTop: 2 }}>
								<img src={ffAd_BlackCircle} alt="" style={{ height: 11, width: 11 }}></img>
								<div className={classes.skipInfoWhiteIcon}>
									<img src={ffAd_icon} alt="" style={{ height: 9, width: 9 }}></img>
								</div>
							</div>
							<div className={classes.overlaySkipInfoText}>
								{adSkipInfo?.adSkipping === infoMsgSkipAd.ALLOWED ? l10n.featureDetailsAlternativeAdIndicatorTitleForPremium : l10n.featureDetailsAlternativeAdIndicatorTitleForNonPremium}
							</div>
						</div>
						}
						*/}
						{/* MTVW-808: tweaks, moved to ProgramDetailsInfo */}
						{/*<RecordingIndicators event={oEventData} showText={true} />*/}
					</Grid>
					{replaySetting &&
						<ConfirmationDialog
							title={l10n.featureSettingsReplayTitle}
							onCloseHandler={() => { setReplaySetting(false) }}
							bodyButtons={replayInfo}
							bottomButtons={
								[{
									bType: ButtonGeneric,
									props: {
										bId: `buttonRecordEpisode_confirm`, variant: "primary",
										label: l10n.commonActionClose, // "Schliessen"
										onClick: () => { setReplaySetting(false) },
										dataTest: "confirm"
									}
								}
								]}
						>
							{l10n.featureSettingsJumpToReplaySettings.format(getMainProfile()?.name).replaceAll("\\n", "\n")}
						</ConfirmationDialog>
					}
					{panelInfo?.info &&
						<InfoPanel bId={`infoPanel1${origin}`} label={panelInfo.info} dataTest="info-panel"
							buttonLabel={panelInfo.buttonLabel ?? null}  onClick={(e) => panelInfo.action(e)}
						/>
					}
					<Grid size={12}>
						{/*console.debug("oEventData_ %o", oEventData.recommendations)*/}
						<div id={`recordInfoContainer_${origin}`} className="overlayRecordInfoContainer">
							{bookmarkFetched &&
								<>
									{buttonsCollect()}
									<PlayButtons />
									<RecordingButtons oEvent={oEventData} origin={origin} buttonAdd={buttonAdd} buttonRemove={buttonRemove} buttonsCommit={buttonsCommit} />
									<SubsribePremiumButton />
									<RenderButtons bArray={buttons} />
								</>
							}
						</div>
					</Grid>
					<Grid size={12}>
						<Typography variant="body1" data-test="detail_info_long_synopsis"
							sx={{ marginBottom: "16px" }}
						>
							{synopsis(oEventData)}
						</Typography>
					</Grid>
					<Grid size={12}>
						<EpgChannelDetailsToolsInfo data-test="detail_info_tech_description" oEvent={oEventData} origin={origin} />
					</Grid>
				</Grid>

				{/* MTVW-898: Set resetOverlay */}
				{episodesArray?.length > 0 &&
					<>
						{season(oEventData) ?
							<div className="episodeTitle">{l10n.featureEpisodeSeasonNumber.format(season(oEventData))}</div>
							:
							<div className="episodeTitle">{l10n.featureEpisodeMoreEpisodes}</div>
						}
						{/* MTVW-1081: id="moreEpisodesCarousel" */}
						<div id="moreEpisodesCarousel"/>
						{/* MTVW-931, finding 2: add resetOverlay */}
						<DiscoverCarousel variant={"episode"} page={page} oEventData={oEventData} contentArray={episodesArray} origin={origin} resetOverlay={resetOverlayDetailsForEpisodeCarousel} />
						<div className="allEpisodesButton" onClick={(e) => {
							// launch search, see OverlayEventDetailsComponent
							if (rootStore.page.OverlayEventDetails.isVisible) {
								// MTVW-624: combined activityStack for related content and search
								rootStore.page.OverlayEventDetails.pushActivity({ type: 'related', id: eventId(oEventData) })
								//rootStore.page.OverlayEventDetails.pushActivity({ type: page.CATEGORY_SERIES, idSerie: page.id(item) })
							}
							e.stopPropagation()
							rootStore.page.Search.setSeasonSelected(season(oEventData) ? season(oEventData).toString() : rootStore.page.Search.ALL_SEASON_SELECTED)
							rootStore.page.OverlayEventDetails.setComponentType(rootStore.page.Search.CATEGORY_SERIES)
								.setSeriesId(seriesCollectionId(oEventData)).setSeriesTitle(title(oEventData))
								.setShow(true, /*callingContext*/ CALLING_CONTEXT_TYPE.keepOldContext)
							setTimeout(() => {
								rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.seriesRelatedPrograms, series: seriesId(oEventData) })
								// MTVW-1011, MTVW-1016 item 2: FILTER_EVENT_LIVE_REPLAY instead of FILTER_EVENT_ALL
								rootStore.page.Search.setFilterEventType(rootStore.page.Search.FILTER_EVENT_LIVE_REPLAY)
								// MTVW-1011, MTVW-1016 item 2: ALL_SEASON_SELECTED
								rootStore.page.Search.setSeasonSelected(rootStore.page.Search.ALL_SEASON_SELECTED)
								rootStore.page.Search.setEpisodeSelectedId(eventId(oEventData))
							}, 200)
						}}>
							<div className="allEpisodesLabel">{l10n.featureEpisodeViewAll}</div>
						</div>
					</>
				}
				{personsArray?.length > 0 &&
					<>
						<div id="peopleGap" style={{ marginTop: 40, width: "100%" }} />
						<DiscoverCarousel variant={"person"} page={page} oEventData={oEventData} contentArray={personsArray} origin={origin} />
					</>
				}
			</div>
		)
	)
})
